import{Logger as m}from"aws-amplify";const o=o=>new m(`AmplifyUI:${o}`);export{o as getLogger};
